
import { Switch } from '@progress/kendo-react-inputs';
import { useIsAisActive, useSetIsAisActive } from '../../../hooks/useMapStore';

export const MapControlAis = () => {

    const isAisActive = useIsAisActive();
    const setIsAisActive = useSetIsAisActive();

    return (
        <div style={{ paddingLeft: 10 }}>
            <Switch
                checked={isAisActive}
                onChange={() => setIsAisActive(!isAisActive)}
                size="medium"
                onLabel={'AIS'}
                offLabel={'AIS'}
            />
        </div>
    )
}
